function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isNil from 'lodash/isNil';
import sortBy from 'lodash/sortBy';
import toPairs from 'lodash/toPairs';
import zipObject from 'lodash/zipObject';
export default {
  props: {
    group: {
      type: String,
      required: true
    },
    frequencyPerValue: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderedTable: function orderedTable() {
      var _this = this;

      var groups = this.$ncsConfig.result.full_frequency.groups;
      return sortBy(toPairs(this.frequencyPerValue), function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            frequency = _ref2[1];

        if (groups[_this.group] && groups[_this.group].sortBy) {
          return groups[_this.group].sortBy(name, frequency);
        } else {
          // For a regular field, sort by their translated value.
          // Except if value is null or empty string. In that case value will be used.
          return _this.$tOr("result.full_frequency.".concat(_this.group, ".values"), name);
        }
      });
    }
  },
  methods: {
    perMillion: function perMillion(frequency) {
      if (frequency.elements === 0 && frequency.elements_reference === 0) {
        // This case can only happen when there is one group value that only matches documents with no elements
        return 0;
      } else {
        return this.$fn(Math.round(frequency.elements * 1000000 / frequency.elements_reference));
      }
    },
    filters: function filters(name) {
      var groups = this.$ncsConfig.result.full_frequency.groups;
      var filters = {};

      if (groups[this.group] && groups[this.group].getValues) {
        // Do nothing if the value for multiple filters is null or 'null' (special value it does not belong to any group)
        if (isNil(name) || name === 'null') return null;
        var values = groups[this.group].getValues(name);
        if (isNil(values)) return null; // Do nothing if an array of values cannot be extracted

        filters = zipObject(groups[this.group].filters, values);
      } else {
        filters = _defineProperty({}, this.group, name);
      }

      return filters;
    },
    hasLink: function hasLink(name) {
      // There is no way to represent an undefined, null or empty string value in filters, so these values does not have a link.
      return !isNil(name) && name !== '' && !isNil(this.filters(name));
    },
    showKwic: function showKwic(name) {
      this.$store.dispatch('api/navigateToResultType', 'kwic');
      this.$store.commit('filters/setFilterIfMoreStrict', this.filters(name));
      this.$store.dispatch('pagination/changePage', 1);
    }
  }
};